import { render, staticRenderFns } from "./latest-traject.vue?vue&type=template&id=5e256878"
import script from "./latest-traject.vue?vue&type=script&lang=js"
export * from "./latest-traject.vue?vue&type=script&lang=js"
import style0 from "./latest-traject.vue?vue&type=style&index=0&id=5e256878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports